
import {
    SET,
    REINIT
} from './types';

import {
    Actions,
} from './actions';

import {
    InteractionModal
} from 'one-state-genesysinteraction/src/InteractionModal';

export const conversationreducer = (
    context: any,
    initial?:InteractionModal,
) => {
    const initValue = initial || {};

    return (
        state: InteractionModal = initValue,
        action:Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
        let updated = state;
        switch (type) {
            case SET:
                updated = payload
                break;

            case REINIT:
                updated = initValue;
                break;
        }
        return updated;
    }
};
